/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN FEE MASTER SELECTORS
 * Role: Admin
 * Scope: Memoized state selectors for fee templates
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

export const selectFeeMasterState = (state) =>
  state.admin?.feeMaster || state.feeMaster || {};

export const selectFeeMasters = (state) =>
  selectFeeMasterState(state).feeMasters || [];

export const selectFeeMasterLoading = (state) =>
  selectFeeMasterState(state).loading || false;

export const selectFeeMasterError = (state) =>
  selectFeeMasterState(state).error || null;